import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { BUILDING_TYPE_HOUSE, BUILDING_TYPE_MANSION } from '../../Constants';
/**
 * 建築物選択ダイアログ
 */
class BuildingTypeSelectDialog extends Dialog {
  /**
       * コンストラクタ
       */
  constructor(draggable: boolean) {
    super(draggable);

    // ダイアログのコンテンツ生成
    const id = 'buildingTypeSelectDialog';
    // タイトル
    let title = '建築物の選択';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = 'モードの選択'; break;
      default: title = 'Building Type Select'; break;
    }

    let contents = '<div class="selectBody">';
    contents += '<div class="selectTitle"><span class="jp">作図する建物種類を選択してください</span>';
    contents += '<span class="en">Select the building you want to draw.</span></div>';
    contents += '<div class="btns">';
    // contents += `<div><input type="radio" name="radioType" id="radioTypeHouse" value="${BUILDING_TYPE_HOUSE}" checked><label for="radioTypeHouse"><span class="jp">戸建て</span><span class="en">House</span></label></div>`;
    // contents += `<div><input type="radio" name="radioType" id="radioTypeMansion" value="${BUILDING_TYPE_MANSION}"><label for="radioTypeMansion"><span class="jp">マンション</span><span class="en">Mansion</span></label></div>`;

    contents += '<button id="buttonTypeHouse"><img src="assets/mode_house.png" width="120px" height="120px"></button>';
    contents += '<button id="buttonTypeMansion"><img src="assets/mode_mansion.png" width="120px" height="120px"></button>';
    contents += '</div>';

    // const footer = '<button id="btnOK"><span class="jp">OK</span><span class="en">OK</span></button>';
    const footer = '';

    this.createDialog(id, title, contents, footer);

    // document.getElementById('btnOK').addEventListener('click', this.onBtnOkClicked);
    document.getElementById('buttonTypeHouse').addEventListener('click', this.onBtnModeClicked);
    document.getElementById('buttonTypeMansion').addEventListener('click', this.onBtnModeClicked);
  }

  /**
   * モードボタンが押された
   */
  onBtnModeClicked = (e) => {
    e.preventDefault();

    console.log((e.target as HTMLButtonElement).value);

    const selectedMode:number = ((e.target as HTMLButtonElement).id === 'buttonTypeHouse') ? BUILDING_TYPE_HOUSE : BUILDING_TYPE_MANSION;
    // 建築モードの更新
    marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType = selectedMode;
    if (selectedMode === BUILDING_TYPE_MANSION) {
      (<HTMLInputElement>document.getElementById('btnRoomDragInput')).checked = false;
      (<HTMLInputElement>document.getElementById('btnRoomKakomiInput')).checked = true;
      marietta.webcad.WebCADGlobal.changeFloor(1);
    }

    // アイテムメニュー初期表示
    marietta.webcad.WebCADGlobal.itemMenu.initView();
    this.close();
  }
}

export default BuildingTypeSelectDialog;
